<section id="the_initiative_container" class="the_initiative_container">
  <div [@slideInOut]
    class=" flex flex-col items-start justify-start gap-6 py-32 md:py-24 lg:py-48 px-4 md:pl-14 lg:pl-[108px]">
    <p class="text-hurrey-24 md:text-hurrey-28 lg:text-hurrey-36 text-purple_100" id="our-vision-head"> The Initiative
    </p>
    <p class="text-hurrey-16 text-black break-words md:w-[70%]" id="initiative_content"> Digital Pathashala reimagines
      how rural India experiences education. Through the partnership between Atomo's <strong>AI-powered learning platform, Build
      a Class Initiative's grassroots implementation expertise,</strong> and <strong>AMNS India's CSR commitment</strong>, we're bridging the
      digital divide one classroom at a time.</p>

    <p class="text-hurrey-16 text-black break-words md:w-[70%]" id="initiative_sub_content"> This flagship initiative
      transforms traditional government school classrooms into dynamic, AI-enabled learning environments where every
      student regardless of geographic or economic background gains access to individualized, technology-driven education.
    </p>


  </div>
</section>
